import React, { Component } from 'react';
import Helmet from "react-helmet";
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import Cards from '../../components/toto/cards';

// @inject('lineStore')
// @withRouter
export default class CardsPage extends Component { 
	render() {
			return(
				<div className="toto-page">
					<Helmet>
						<title>ИРМ - Карточки тотализатора</title>
					</Helmet>
					<div className="toto-page__body">
						<Cards />
					</div>
				</div> 
			)
	}
}


// WEBPACK FOOTER //
// ./src/routes/toto/cards.jsx